import React, { useState } from "react";
import OtpInput from "react18-input-otp";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { sendOTP, verifyOTP } from "../../../actions";

const MessageConfirmation = (props) => {
  const { dark } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [showError, setShowError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isResent, setIsResent] = useState(false);

  const handleChange = (enteredOtp) => {
    setOtp(enteredOtp);
    setShowError(false);
  };

  const handleSubmit = () => {
    if (otp.length !== 6) { setShowError(true); return; }
    setIsSubmitting(true);
    dispatch(verifyOTP(
      { email: props.mail, otp },
      () => navigate("/createpassword"),
    ));
  };

  const handleResend = () => {
    dispatch(sendOTP(props.mail));
    setIsResent(true);
    setTimeout(() => setIsResent(false), 3000);
  };

  return (
    <>
      <div className="mb-7 text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full mb-4" style={dark ? { background: 'rgba(99,102,241,0.2)' } : { background: '#eff6ff' }}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={dark ? { color: 'rgba(165,180,252,0.9)' } : { color: '#2563eb' }}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div>
        <h1 className="text-2xl font-semibold mb-1.5" style={dark ? { color: 'rgba(255,255,255,0.95)' } : { color: '#111827' }}>Check your email</h1>
        <p className="text-sm" style={dark ? { color: 'rgba(255,255,255,0.5)' } : { color: '#6b7280' }}>
          We sent a 6-digit code to{' '}
          <span className="font-medium" style={dark ? { color: 'rgba(255,255,255,0.8)' } : { color: '#374151' }}>{props.mail}</span>
        </p>
      </div>

      <div className="flex justify-center mb-2">
        <OtpInput
          value={otp}
          onChange={handleChange}
          numInputs={6}
          isInputNum
          hasErrored={showError}
          shouldAutoFocus
          separator={<span className="w-2" />}
          inputStyle={{
            width: '44px',
            height: '52px',
            fontSize: '20px',
            fontWeight: '600',
            textAlign: 'center',
            border: showError
              ? '2px solid rgba(248,113,113,0.7)'
              : dark ? '2px solid rgba(255,255,255,0.15)' : '2px solid #e5e7eb',
            borderRadius: '12px',
            outline: 'none',
            transition: 'border-color 0.15s',
            color: dark ? 'rgba(255,255,255,0.9)' : '#111827',
            background: dark ? 'rgba(255,255,255,0.08)' : '#fff',
          }}
          focusStyle={{
            borderColor: dark ? 'rgba(99,102,241,0.8)' : '#3b82f6',
            boxShadow: dark ? '0 0 0 3px rgba(99,102,241,0.2)' : '0 0 0 3px rgba(59,130,246,0.15)',
          }}
        />
      </div>

      {showError && (
        <p className="text-xs text-red-400 text-center mb-2">Please enter the complete 6-digit code</p>
      )}

      <button
        onClick={handleSubmit}
        disabled={isSubmitting || otp.length !== 6}
        className={`mt-4 w-full py-2.5 px-4 text-white text-sm font-semibold rounded-xl shadow-sm ${dark ? 'auth-btn-primary' : 'bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300 transition-colors duration-150'}`}
      >
        {isSubmitting
          ? <span className="flex items-center justify-center gap-2">
              <svg className="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
              </svg>
              Verifying…
            </span>
          : 'Verify code'
        }
      </button>

      <p className="mt-5 text-center text-sm" style={dark ? { color: 'rgba(255,255,255,0.4)' } : { color: '#6b7280' }}>
        Didn't receive a code?{' '}
        <button
          type="button"
          onClick={handleResend}
          className="font-medium"
          style={dark ? { color: 'rgba(147,197,253,0.9)' } : { color: '#2563eb' }}
        >
          {isResent ? 'Sent!' : 'Resend code'}
        </button>
      </p>
    </>
  );
};

export default MessageConfirmation;
